"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Pagination(_ref) {
  var currentIndex = _ref.currentIndex,
    totalItems = _ref.totalItems,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Item" : _ref$label;
  if (totalItems <= 1) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "mb-4 inline-flex items-center gap-1 text-xs",
    "data-sentry-component": "Pagination",
    "data-sentry-source-file": "Pagination.tsx",
    children: [label, " ", currentIndex + 1, " of ", totalItems, /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "outline",
      size: "icon-sm",
      "aria-label": "Previous",
      onClick: onPrev,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "Pagination.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
        "data-sentry-element": "ChevronLeftIcon",
        "data-sentry-source-file": "Pagination.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "outline",
      size: "icon-sm",
      "aria-label": "Next",
      onClick: onNext,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "Pagination.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        "data-sentry-element": "ChevronRightIcon",
        "data-sentry-source-file": "Pagination.tsx"
      })
    })]
  });
}
var _default = exports.default = Pagination;